var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"outline":"","clear-icon":'close',"clearable":"","placeholder":'HH:MM'},on:{"keyup":_vm.onChange,"blur":_vm.onChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})}
var staticRenderFns = []

export { render, staticRenderFns }